import React from 'react';
import type { LineOption } from '@/types/properties';
import type { DynamicComponentProps } from '@/types/commontypes';
import { ColorPicker, LineWidthDashPicker } from '../shape.map';
import PencilIcon from '@/assets/svg/pencil_icon.svg';
import styles from '../../../styles/global.module.css';

const LineOptionComponent: React.FC<DynamicComponentProps<LineOption>> = ({
  label,
  value,
  onChange,
  isFromMiniToolbar,
}) => {
  const { strokeStyle, ...lineWidthDashOption } = value;

  const handleColorChange = (newValue: string) => {
    // const rgbaFormat = handleColorFormat(newValue)
    const updatedValue = { ...value, strokeStyle: newValue };
    onChange(updatedValue);
  };

  const fromMiniToolbar = isFromMiniToolbar === undefined ? false : true;

  if (fromMiniToolbar) {
    return (
      <div className="flex items-center">
        <div className={`flex items-center ml-0.5 sm:ml-2 flex-row space-x-2`}>
          <ColorPicker
            value={strokeStyle || '#787b86'}
            onChange={handleColorChange}
            isFromMiniToolbar={fromMiniToolbar}
            svgIcon={PencilIcon}
          />
          <LineWidthDashPicker
            value={lineWidthDashOption}
            onChange={updatedLineWidthDashOption => {
              onChange({ ...updatedLineWidthDashOption, strokeStyle });
            }}
            isFromMiniToolbar={isFromMiniToolbar}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.property_row}>
      {label && <label className={styles.property_label}>{label}</label>}
      <div className={styles.property_value}>
        <ColorPicker
          value={strokeStyle || '#787b86'}
          onChange={handleColorChange}
          isFromMiniToolbar={fromMiniToolbar}
          svgIcon={PencilIcon}
        />
        <LineWidthDashPicker
          value={lineWidthDashOption}
          onChange={updatedLineWidthDashOption => {
            onChange({ ...updatedLineWidthDashOption, strokeStyle });
          }}
          isFromMiniToolbar={isFromMiniToolbar}
        />
      </div>
    </div>
  );
};

export default LineOptionComponent;
